import './LockedUserView.scss';

export function LockedUserView() {
  return (
    <div className='user-locked-container'>
      <p className='no-access-text'>Access Forbidden.</p>
    </div>
  );
}
